import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bay-empty-state',
  template: `
    <div class="bay-empty" [class.bay-empty-compact]="compact">
      <span class="material-symbols-outlined bay-empty-icon" aria-hidden="true">{{ icone }}</span>
      <p class="bay-empty-title">{{ titre }}</p>
      <p *ngIf="texte" class="bay-empty-text">{{ texte }}</p>
      <button *ngIf="action" type="button" class="bay-btn bay-btn-primary" (click)="agir.emit()">
        <span *ngIf="actionIcone" class="material-symbols-outlined" aria-hidden="true">{{ actionIcone }}</span>{{ action }}
      </button>
      <ng-content></ng-content>
    </div>
  `
})
export class EmptyStateComponent {
  @Input() icone = 'inbox';
  @Input() titre = '';
  @Input() texte = '';
  @Input() action = '';
  @Input() actionIcone = '';
  @Input() compact = false;
  @Output() agir = new EventEmitter<void>();
}
